import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ContentState, setupContentStateRouteListener } from '@core/utils/route-utils'
import { PermissionService } from '@core/auth/services/permission.service'
import { TemplateDisplayComponent } from '@features/template/components/template-display/template-display.component'
import { TemplateCtaButtonComponent } from '@features/template/components/template-cta-btn/template-cta-btn.component'
import { TemplateManagerService } from './services/template-manager.service'

@Component({
  selector: 'albert-template',
  standalone: true,
  templateUrl: './template.component.html',
  styleUrl: './template.component.css',
  imports: [
    TemplateDisplayComponent,
    TemplateCtaButtonComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [TemplateManagerService]
})
export class TemplateComponent implements OnInit {
  public readonly manager = inject(TemplateManagerService)
  public readonly contentState = signal<ContentState>('none')
  protected readonly permissionService = inject(PermissionService)
  private readonly route = inject(ActivatedRoute)
  private readonly destroyRef = inject(DestroyRef)

  public ngOnInit(): void {
    setupContentStateRouteListener(this.route, this.destroyRef, this.manager.contentState, this.contentState)
  }
}
